module.exports = __webpack_public_path__ + "static/media/card2_8.0a623006.png";